import React, { Component, Fragment } from "react";
import CircularLoadingScreen from "../../commons/CircularLoadingScreen";
import postService from "../../../services/postService";
import User from "../../commons/User";
import userService from "../../../services/userService";
import { Link } from 'react-router-dom';

class ProfileFollowers extends Component {
  state = { loaded: false, users: [] };

  async componentDidMount() {
    await this.loadUserFollowers();
  }

  loadUserFollowers = async () => {
    setTimeout(async () => {
      const username = this.props.match.params.name;
      const response = await userService.getFollowers(username);
      const userFollowers = response.data.data;
      this.setState({ loaded: true, users: userFollowers });
    }, 500);
  };

  render() {
    const { loaded, users } = this.state;
    return (
      <Fragment>
        {!loaded ? (
          <CircularLoadingScreen thickness={5} />
        ) : (
          <div>
            {users.length == 0 ? (
              <p
                style={{
                  textAlign: "center",
                  margin: 10,
                  marginTop: 20,
                  color: "grey",
                }}
              >
                This user has no followers
              </p>
            ) : (
              <div>
                {users.map((user) => (
                  <Link key={user.id} to={`/profile/${user.username}`} style={{
                    color: 'black',
                    textDecoration: 'none'
                  }}>
                    <User user={user} key={user.id} />
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

export default ProfileFollowers;
